import React from 'react'
import SpecialCourseManagement from './SpecialCourseManagement/SpecialCourseManagement'
import SpecialCoursesOverview from './SpecialCourseOverview/SpecialCoursesOverview'
import SpecialCertificate from './SpecialCertificate/SpecialCertificate'
import SpecialKeyModules from './SpecialKeyModules/SpecialKeyModules'
import SpecialCareer from './SpecialCareer/SpecialCareer'
import WhySpecial from './WhySpecial/WhySpecial'
import SGallery from './SGallery/SGallery'


function Bar() {
  return (
    <>
      <SpecialCourseManagement/>
      <SpecialCoursesOverview/>
      <SpecialCertificate/>
      <SpecialKeyModules/>
      <SpecialCareer/>
      <WhySpecial/>
      <SGallery/>
    </>
  )
}

export default Bar
